import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaPlus } from 'react-icons/fa';
import IconRenderer from '../IconRenderer';

const SocialIconForm = ({ onAdd }) => {
  const [type, setType] = useState('youtube');
  const [link, setLink] = useState('');

  const iconTypes = [
    { value: 'youtube', label: 'YouTube' },
    { value: 'instagram', label: 'Instagram' },
    { value: 'facebook', label: 'Facebook' },
    { value: 'twitter', label: 'Twitter / X' },
    { value: 'tiktok', label: 'TikTok' },
    { value: 'linkedin', label: 'LinkedIn' },
    { value: 'whatsapp', label: 'WhatsApp' },
    { value: 'custom', label: 'Custom Link' },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!link.trim()) {
      alert('Please enter a link');
      return;
    }

    const selectedIcon = iconTypes.find(icon => icon.value === type);
    
    onAdd({
      type,
      iconName: selectedIcon.label,
      link: link.trim(),
    });

    // Reset form
    setLink('');
    setType('youtube');
  };

  const getIconColor = (iconType) => {
    const colors = {
      youtube: 'text-red-500',
      instagram: 'text-pink-500',
      facebook: 'text-blue-500',
      twitter: 'text-blue-400',
      tiktok: 'text-gray-300',
      linkedin: 'text-blue-600',
      whatsapp: 'text-green-500',
      custom: 'text-purple-500',
    };
    return colors[iconType] || 'text-gray-400';
  };

  return (
    <form onSubmit={handleSubmit} className="bg-[#1a1a3e] border border-gray-800 rounded-xl p-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Icon Type Dropdown */}
        <div>
          <label className="block text-gray-300 mb-2 font-medium text-sm">Icon Type</label>
          <select
            value={type}
            onChange={(e) => setType(e.target.value)}
            className="w-full px-4 py-3 bg-[#0a0a1f] border border-gray-700 rounded-xl text-white focus:border-purple-500 focus:outline-none transition-colors"
          >
            {iconTypes.map((icon) => (
              <option key={icon.value} value={icon.value}>
                {icon.label}
              </option>
            ))}
          </select>
        </div>

        {/* Link Input */}
        <div className="md:col-span-2">
          <label className="block text-gray-300 mb-2 font-medium text-sm">Link URL</label>
          <div className="flex gap-2">
            <input
              type="url"
              value={link}
              onChange={(e) => setLink(e.target.value)}
              placeholder="https://example.com/yourprofile"
              className="flex-1 px-4 py-3 bg-[#0a0a1f] border border-gray-700 rounded-xl text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none transition-colors"
              required
            />
            <motion.button
              type="submit"
              className="px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl font-semibold hover:from-purple-700 hover:to-pink-700 transition-all flex items-center gap-2"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <FaPlus />
              Add Icon
            </motion.button>
          </div>
        </div>
      </div>

      {/* Preview */}
      <div className="mt-4 p-4 bg-[#0a0a1f] rounded-xl border border-gray-800">
        <p className="text-gray-400 text-sm mb-2">Preview:</p>
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#1a1a3e] rounded-lg flex items-center justify-center">
            <IconRenderer 
              type={type} 
              size={24} 
              className={getIconColor(type)}
            />
          </div>
          <div>
            <p className="text-white font-medium">{iconTypes.find(i => i.value === type)?.label}</p>
            <p className="text-gray-500 text-sm truncate">{link || 'Enter link above'}</p>
          </div>
        </div>
      </div>
    </form>
  );
};

export default SocialIconForm;
